/*
 resolveConfig from Tailwind has been deprecated in v4.
 This util replaces it so we can still get the value of a theme variable.

 Ref: https://tailwindcss.com/docs/theme#referencing-in-javascript
*/

export const getTailwindThemeVariable = (variables: string[]): Record<string, string> => {
  if (typeof window === 'undefined') return {};
  const styles = getComputedStyle(document.documentElement);
  const theme: Record<string, string> = {};

  for (const key of variables) {
    const val = styles.getPropertyValue(key);
    theme[key] = val;
  }
  // An accumulator returned at its boundary; callers narrow what they read from it.
  // oxlint-disable-next-line anti-slop/no-known-value-widening
  return theme;
};
